import React from 'react';

import localyserLogo from '../../../assets/localyserLogo.png'

const Header = () => {
  return (
    <header className="bg-white shadow-sm border-b border-gray-200">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-6">
          <div className="w-32">
            <img src={localyserLogo} alt="Localyser logo"/>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
